export default "__VITE_ASSET__Dyoyxy1N__"